import _ from 'lodash';
import { gEnums } from '../../../enums/globalEnums';

export const postDataConstraits = (whereOpts, vld, uivi) => {

  let _vld = vld
  const { posts: wherez, _postz } = whereOpts ?? {}

  let allData = _.cloneDeep(vld)

  // add the data items
  const { hasConstraint: hasConstraintI, allItems: _allItems } = dataIncluded(wherez, allData)
  const { hasConstraint: hasConstraintN, allItems: _allItemsN } = dataIncludedN(_postz, allData)

  // remove the data items 
  const { hasConstraint: hasConstraintE, allItems, excludedData } = dataExcluded(wherez, allData, _allItems)

  return hasConstraintI || hasConstraintE ? { postData: allItems, excludedData } : { postData: _vld }

}

// const getConstraintType = (queryType) => {
//   switch (queryType) {
//     case gEnums.queryTypes.arrayContains: return 'array-contains';
//     case gEnums.queryTypes.arrayContainsAny: return 'array-contains-any';
//     case gEnums.queryTypes.equalTo: return '==';
//     case gEnums.queryTypes.greaterThan: return '>';
//     case gEnums.queryTypes.greaterThanOrEqualTo: return '>=';
//     case gEnums.queryTypes.in: return 'in';
//     case gEnums.queryTypes.lessThan: return '<';
//     case gEnums.queryTypes.lessThanOrEqualTo: return '<=';
//     case gEnums.queryTypes.notEqualTo: return '!=';
//     case gEnums.queryTypes.notIn: return 'not-in';
//     default: return '==';
//   }
// };

// const filterComplexObject = (complexObject, dataConstraints) => {
//   return _.pickBy(complexObject, (item) => {
//     // Check if the item satisfies all constraints
//     return _.every(dataConstraints, (constraint) => {
//       const { itemProp, constraintType, itemValue } = constraint;
//       // const constraintType = getConstraintType(queryType);
//       const value = _.get(item, itemProp);

//       switch (constraintType) {
//         case 'array-contains':
//           return _.isArray(value) && _.includes(value, itemValue);
//         case 'array-contains-any':
//           return _.isArray(value) && _.some(itemValue, val => _.includes(value, val));
//         case '==':
//           return value === itemValue;
//         case '>':
//           return value > itemValue;
//         case '>=':
//           return value >= itemValue;
//         case '<':
//           return value < itemValue;
//         case '<=':
//           return value <= itemValue;
//         case '!=':
//           return value !== itemValue;
//         case 'in':
//           return _.includes(itemValue, value);
//         case 'not-in':
//           return !_.includes(itemValue, value);
//         default:
//           return true; // Default to include item if no valid constraint
//       }
//     });
//   });
// };

export const postKeyConstraits = (fsr, vld) => {

  let _vld = vld
  const { whereOpts } = fsr ?? {}
  const { dataKeys } = whereOpts ?? {}

  if (dataKeys && dataKeys.length > 0 && _vld) {
    Object.keys(_vld).forEach(k => {
      if (!dataKeys.includes(k)) {
        delete _vld[k]
      }
    })
  }

  return _vld

}

/**
 * 
 * @param {array} posts 
 * @param {object} allData 
 * @returns 
 */
const dataIncluded = (wherez, allData) => {

  let hasConstraint;
  let _allItems = {};

  wherez.forEach(wz => {

    // const { Hc: constraintType, Jc: itemValue, zc } = wz ?? {}
    // const { wc: constraintType, mc: itemValue, _c } = wz ?? {}
    // const { da: constraintType, _a: itemValue, fa: segHolder } = wz ?? {}
    const { _op: constraintType, _value: itemValue, _field: segHolder } = wz ?? {}
    const { segments } = segHolder ?? {}
    const itemProp = segments ? segments[0] : null

    let _itemValue = itemValue

    if (!_.isArray(itemValue) && !_.isObject(itemValue)) {
      if (itemValue && itemValue.toLowerCase() === 'true') {
        _itemValue = true
      } else if (itemValue && itemValue.toLowerCase() === 'false') {
        _itemValue = true
      }
    }

    switch (constraintType) {
      // case gEnums.queryTypes.arrayContains:
      case 'array-contains':
        // IMPORTANT: Data - Filter array-contains 
        if (itemProp) {
          const _allData1 = _.filter(allData, function (item) {
            const ivv = item[itemProp]
            if (_.isArray(_itemValue)) {
              return ivv && _.isArray(ivv) && ivv.some(r => _itemValue.includes(r))
            } else {
              return ivv && _.isArray(ivv) && ivv.includes(_itemValue);
            }
          })
          hasConstraint = true
          _allData1.forEach(a => { _allItems[a._itemKey] = a })
        }
        break;
      // case gEnums.queryTypes.arrayContainsAny:
      case 'array-contains-any':
        if (_.isArray(_itemValue)) {
          const _allData2 = _.filter(allData, function (item) {
            const iv = item[itemProp]
            return iv && _.isArray(iv) && iv.some(r => _itemValue.includes(r))
          })
          hasConstraint = true
          _allData2.forEach(a => { _allItems[a._itemKey] = a })
        }

        break;

      case '==':
        if (itemProp) {
          const _allData3 = _.filter(allData, function (item) {
            return (item[itemProp] && item[itemProp] === _itemValue);
          })
          hasConstraint = true
          _allData3.forEach(a => { _allItems[a._itemKey] = a })
        }
        break;
      // case gEnums.queryTypes.greaterThan:
      case '>':
        break;
      // case gEnums.queryTypes.greaterThanOrEqualTo:
      case '>=':
        break;
      // case gEnums.queryTypes.in:
      case 'in':
        break;
      // case gEnums.queryTypes.lessThan:
      case '<':
        break;
      // case gEnums.queryTypes.lessThanOrEqualTo:
      case '<=>':
        break;
      default:
    }
  })

  if (!hasConstraint) {
    return { allItems: allData, hasConstraint }
  } else {
    return { allItems: _allItems, hasConstraint }
  }

}

const dataIncludedN = (wherez, allData) => {

  let hasConstraint;
  let _allItems = {};

  if (wherez) {
    wherez.forEach(wz => {

      // const { Hc: constraintType, Jc: itemValue, zc } = wz ?? {}
      // const { wc: constraintType, mc: itemValue, _c } = wz ?? {}
      // const { da: constraintType, _a: itemValue, fa: segHolder } = wz ?? {}
      const { constraintType, itemValue, itemProp } = wz ?? {}

      let _itemValue = itemValue

      if (!_.isArray(itemValue) && !_.isObject(itemValue)) {
        if (itemValue && itemValue.toLowerCase() === 'true') {
          _itemValue = true
        } else if (itemValue && itemValue.toLowerCase() === 'false') {
          _itemValue = true
        }
      }

      switch (constraintType) {
        // case gEnums.queryTypes.arrayContains:
        case 'array-contains':
          // IMPORTANT: Data - Filter array-contains 
          if (itemProp && _.isArray(_itemValue)) {
            const _allData1 = _.filter(allData, function (item) {
              const ivv = item[itemProp]
              if (_.isArray(_itemValue)) {
                return ivv && _.isArray(ivv) && ivv.some(r => _itemValue.includes(r))
              } else {
                return ivv && _.isArray(ivv) && ivv.includes(_itemValue);
              }
            })
            hasConstraint = true
            _allData1.forEach(a => { _allItems[a._itemKey] = a })
          }
          break;
        // case gEnums.queryTypes.arrayContainsAny:
        case 'array-contains-any':
          if (_.isArray(_itemValue)) {

            const _allData2 = _.filter(allData, function (item) {
              const iv = item[itemProp]
              return iv && _.isArray(iv) && iv.some(r => _itemValue.includes(r))
            })
            hasConstraint = true
            _allData2.forEach(a => { _allItems[a._itemKey] = a })
          }
          break;

        case '==':
          if (itemProp) {
            const _allData3 = _.filter(allData, function (item) {
              return (item[itemProp] && item[itemProp] === _itemValue);
            })
            hasConstraint = true
            _allData3.forEach(a => { _allItems[a._itemKey] = a })
          }
          break;
        // case gEnums.queryTypes.greaterThan:
        case '>':
          break;
        // case gEnums.queryTypes.greaterThanOrEqualTo:
        case '>=':
          break;
        // case gEnums.queryTypes.in:
        case 'in':
          break;
        // case gEnums.queryTypes.lessThan:
        case '<':
          break;
        // case gEnums.queryTypes.lessThanOrEqualTo:
        case '<=>':
          break;
        default:
      }
    })
  }


  if (!hasConstraint) {
    return { allItems: allData, hasConstraint }
  } else {
    return { allItems: _allItems, hasConstraint }
  }

}

const dataExcluded = (wherez, allData, _allItems) => {

  let hasConstraint;
  const _excludedData = []

  wherez.forEach(wz => {

    // const { Hc: constraintType, Jc: itemValue, zc } = wz ?? {}
    // const { wc: constraintType, mc: itemValue, _c } = wz ?? {}
    // const { da: constraintType, _a: itemValue, fa: segHolder } = wz ?? {}
    const { _op: constraintType, _value: itemValue, _field: segHolder } = wz ?? {}
    const { segments } = segHolder ?? {}
    const itemProp = segments ? segments[0] : null

    switch (constraintType) {
      // case gEnums.queryTypes.greaterThan:
      case '>':
        break;
      // case gEnums.queryTypes.greaterThanOrEqualTo:
      case '>=':
        break;
      // case gEnums.queryTypes.in:
      case 'in':
        break;
      // case gEnums.queryTypes.lessThan:
      case '<':
        break;
      // case gEnums.queryTypes.lessThanOrEqualTo:
      case '<=>':
        break;
      // case gEnums.queryTypes.notEqualTo: 
      // case gEnums.queryTypes.notIn:
      case '!=':
        if (itemProp && allData) {
          Object.keys(allData).forEach((key, index) => {
            const item = allData[key]
            if (item && item[itemProp]) {
              const pv = item[itemProp]
              if (_.isArray(itemValue)) {
                if (itemValue.includes(pv)) {
                  _excludedData.push(item._itemKey)
                }
              } else {
                if (pv === itemValue) {
                  _excludedData.push(item._itemKey)
                }
              }
            }
            if (_excludedData) {
              _excludedData.forEach(k => {
                delete _allItems[k]
              })
            }
            hasConstraint = true
          })
        }
        break;

      case 'not-in':
        if (itemProp && allData) {
          Object.keys(allData).forEach((key, index) => {
            const item = allData[key]
            if (_.isArray(itemValue)) {
              itemValue.forEach(iv => {
                if (item[itemProp] && item[itemProp].includes(iv)) {
                  _excludedData.push(item._itemKey)
                }
              })
            } else {
              if (item[itemProp] && item[itemProp].includes(itemValue)) {
                _excludedData.push(item._itemKey)
              }
            }
          })
          if (_excludedData) {
            _excludedData.forEach(k => {
              delete _allItems[k]
            })
          }
          hasConstraint = true
        }
        break;
      default:
    }
  })

  return { hasConstraint, allItems: _allItems, excludedData: _excludedData }

}

